const addLocaleData = require('react-intl').addLocaleData; //eslint-disable-line
const enLocaleData = require('react-intl/locale-data/en');
const thLocaleData = require('react-intl/locale-data/th');
const koLocaleData = require('react-intl/locale-data/ko');

const enTranslationMessages = require('./languages/en.json');
const thTranslationMessages = require('./languages/th.json');
const koTranslationMessages = require('./languages/ko.json');

addLocaleData(enLocaleData);
addLocaleData(thLocaleData);
addLocaleData(koLocaleData);

// prettier-ignore
export const appLocales = [
  'en',
  'th',
  'ko',
];

const userLang = navigator.language || navigator.userLanguage;
export const DEFAULT_LOCALE = appLocales.indexOf(userLang) > -1 ? userLang : 'en';

export const formatTranslationMessages = (locale, messages) => {
  const defaultFormattedMessages =
    locale !== DEFAULT_LOCALE
      ? formatTranslationMessages(DEFAULT_LOCALE, enTranslationMessages)
      : {};
  const flattenFormattedMessages = (formattedMessages, key) => {
    const formattedMessage =
      !messages[key] && locale !== DEFAULT_LOCALE
        ? defaultFormattedMessages[key]
        : messages[key];
    return Object.assign(formattedMessages, { [key]: formattedMessage });
  };
  return Object.keys(messages).reduce(flattenFormattedMessages, {});
};

export const translationMessages = {
  en: formatTranslationMessages('en', enTranslationMessages),
  th: formatTranslationMessages('th', thTranslationMessages),
  ko: formatTranslationMessages('ko', koTranslationMessages),
};

